export enum Mode {
  fireplace = 'fireplace-active',
  circulation = 'circulation-active',
  nightMode = 'silent-active',
  unitStopped = 'stop-active',
  holiday = 'holiday-active',
}

